import React, { useRef, useState } from "react"
import useOutsideAlerter from "../../../hooks/useOutsideAlerter"
import Typography from "../../shared/typography/Typography"
import { Item, MenuButton, MenuContainer, Wrapper } from "./style"

export type MenuItemType = {
  icon: React.ReactNode
  title: string
  onClick: () => void
} 

interface IProps {
  buttonIcon: React.ReactNode
  menuItens: MenuItemType[]
  positionY: 'top' | 'bottom'
  positionX: 'left' | 'right'
  onlyIcon?: boolean
}

export const MenuPopover = ({buttonIcon, menuItens, positionY, positionX, onlyIcon=false}: IProps) => {
  const [open, setOpen] = useState(false);

  const menuRef = useRef<HTMLDivElement>(null);

  useOutsideAlerter(menuRef, () => {setOpen(false)});

  return (
    <Wrapper ref={menuRef}>
      <MenuButton onClick={() => setOpen(prev => !prev)} onlyIcon={onlyIcon}>
        {buttonIcon}
      </MenuButton>
      <MenuContainer open={open} positionY={positionY} positionX={positionX}>
        {menuItens.map((item, index) => (
          <Item 
            key={index}
            style={{
              borderRadius: index === 0 ? 
                '8px 8px 0 0' : 
                index === menuItens.length ? 
                '0 0 8px 8px' : 
                'none',
            }} 
            onClick={item.onClick}
          >
            {item.icon}
            <Typography type="buttonXS" color="label">{item.title}</Typography>
          </Item>
        ))}
      </MenuContainer>
    </Wrapper>
  );
}